import { PATTERNS } from '../constants/validations';

export function isValidUrlByRegex(input) {
  if (typeof input !== 'string') return false;

  const value = input.trim();
  if (value.length === 0) return false;

  const re = new RegExp(`^(?:${PATTERNS.URL.source})$`, PATTERNS.URL.flags);

  return re.test(value);
}



// WEBPACK FOOTER //
// ./src/utils/isValidUrlByRegex.js